export enum OnlineBookingStep {
    // Legacy grooming steps (kept for backward compat with existing DB records)
    AddPet = 'add_pet',
    SelectPets = 'select_pets',
    SelectServices = 'select_services',
    SelectStaff = 'select_staff',
    SelectDateTime = 'select_date_time',
    NotesAndAgreements = 'notes_and_agreements',

    // Current steps
    CreatePet = 'create_pet',
    PetList = 'pet_list',
    ServiceCategory = 'service_category',
    ServiceList = 'service_list',
    StaffList = 'staff_availability',
    DatePicker = 'date_picker',
    TimePicker = 'time_picker',
    AddonList = 'addon_list',
    Instructions = 'instructions',
    Checkout = 'check_out'
}

export const OnlineBookingStepNames: Record<string, string> = {
    // Legacy
    [OnlineBookingStep.AddPet]: 'Add Pet',
    [OnlineBookingStep.SelectPets]: 'Select Pets',
    [OnlineBookingStep.SelectServices]: 'Select Services',
    [OnlineBookingStep.SelectStaff]: 'Select Staff',
    [OnlineBookingStep.SelectDateTime]: 'Select Date & Time',
    [OnlineBookingStep.NotesAndAgreements]: 'Notes & Agreements',

    // Current
    [OnlineBookingStep.CreatePet]: 'Add Pet',
    [OnlineBookingStep.PetList]: 'Select Pets',
    [OnlineBookingStep.ServiceCategory]: 'Service Category',
    [OnlineBookingStep.ServiceList]: 'Select Services',
    [OnlineBookingStep.StaffList]: 'Select Staff',
    [OnlineBookingStep.DatePicker]: 'Select Date',
    [OnlineBookingStep.TimePicker]: 'Select Time',
    [OnlineBookingStep.AddonList]: 'Select Add-ons',
    [OnlineBookingStep.Instructions]: 'Feeding & Medication',
    [OnlineBookingStep.Checkout]: 'Checkout'
};

export interface OnlineBookingStepFilterBucket {
    id: string;
    label: string;
    values: Array<OnlineBookingStep>;
}

// Buckets group enum values that share a label so the steps filter shows one
// option per logical step. The legacy SelectDateTime step is included in both
// "Select Date" and "Select Time" so attempts abandoned on the old combined
// screen match either toggle.
export const stepFilterBuckets: Array<OnlineBookingStepFilterBucket> = [
    { id: 'add_pet', label: 'Add Pet', values: [OnlineBookingStep.CreatePet, OnlineBookingStep.AddPet] },
    { id: 'select_pets', label: 'Select Pets', values: [OnlineBookingStep.PetList, OnlineBookingStep.SelectPets] },
    { id: 'service_category', label: 'Service Category', values: [OnlineBookingStep.ServiceCategory] },
    {
        id: 'select_services',
        label: 'Select Services',
        values: [OnlineBookingStep.ServiceList, OnlineBookingStep.SelectServices]
    },
    {
        id: 'select_staff',
        label: 'Select Staff',
        values: [OnlineBookingStep.StaffList, OnlineBookingStep.SelectStaff]
    },
    {
        id: 'select_date',
        label: 'Select Date',
        values: [OnlineBookingStep.DatePicker, OnlineBookingStep.SelectDateTime]
    },
    {
        id: 'select_time',
        label: 'Select Time',
        values: [OnlineBookingStep.TimePicker, OnlineBookingStep.SelectDateTime]
    },
    { id: 'addon_list', label: 'Select Add-ons', values: [OnlineBookingStep.AddonList] },
    { id: 'instructions', label: 'Feeding & Medication', values: [OnlineBookingStep.Instructions] },
    { id: 'notes_and_agreements', label: 'Notes & Agreements', values: [OnlineBookingStep.NotesAndAgreements] },
    { id: 'check_out', label: 'Checkout', values: [OnlineBookingStep.Checkout] }
];
